var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('google-geo-point',{attrs:{"latitude":_vm.latitude,"longitude":_vm.longitude,"styles":{
        height: 'calc(100vh - 350px)'
      }},on:{"update:latitude":function($event){_vm.latitude=$event},"update:longitude":function($event){_vm.longitude=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }